<template>
  <IQOS
    class="pay-receiver-box iqos-empty"
    :readonly="editing"
    :title="$t('settings_cafe.liqpay.title')"
    v-if="canShowBlockAtAll"
  >
    <CircleToggle
      :value="pay_receiver.type == 'card'"
      @input="selectType('card')"
      v-if="allowP2p"
    >{{$t('settings_cafe.liqpay.human')}}</CircleToggle>
    <div class="card-settings" v-if="pay_receiver.type == 'card' && allowP2p">
      <p class="comment" v-if="editing">{{$t('settings_cafe.liqpay.human_explain')}}</p>

      <div class="d-flex w-100 align-items-center">
        <BaseInput
          class="input-pay"
          mask="#### #### #### ####"
          placeholder="4141 4141 4141 4141"
          v-model="pay_receiver.card_number"
          :readonly="!editing || pay_receiver.type != 'card'"
        />
        <img src="../assets/payment-variants.png" class="accept-to-pay" />
      </div>
    </div>

    <CircleToggle
      :value="pay_receiver.type == 'bank_account'"
      @input="selectType('bank_account')"
      class="circle-row"
      v-if="allowP2p"
    >{{$t('settings_cafe.liqpay.company')}}</CircleToggle>
    <div class="bank-account-settings" v-if="pay_receiver.type == 'bank_account'">
      <p class="comment">{{$t('settings_cafe.liqpay.company_explain')}}</p>
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.company_account_number')"
        v-model="pay_receiver.account"
        :readonly="!editing || pay_receiver.type != 'bank_account'"
      />
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.company_mfo')"
        v-model="pay_receiver.mfo"
        :readonly="!editing || pay_receiver.type != 'bank_account'"
      />
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.company_edrpoy')"
        v-model="pay_receiver.okpo"
        :readonly="!editing || pay_receiver.type != 'bank_account'"
      />
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.company_name')"
        v-model="pay_receiver.company"
        :readonly="!editing || pay_receiver.type != 'bank_account'"
      />
    </div>

    <CircleToggle
      :value="pay_receiver.type == 'liqpay_merchant'"
      @input="selectType('liqpay_merchant')"
      :class="{
        'circle-row': true,
        'mt-0': !allowP2p
      }"
      v-if="allowLiqpay"
    >
      <img class="payment-gateway-icon" src="/icons/liqpay.svg"> 
    
    <!-- {{$t('settings_cafe.liqpay.liqpay_account')}}  -->
    
      <span class="c-grey">
        | {{ $t('settings_cafe.liqpay.comission') }} 2.75%
      </span>
    </CircleToggle>

    <div class="liqpay-settings" v-if="pay_receiver.type == 'liqpay_merchant' && allowLiqpay">
      <p class="comment">{{$t('settings_cafe.liqpay.liqpay_api_explain')}}</p>

      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.liqpay_api_pubkey')"
        v-model="pay_receiver.liqpay_public_key"
        :readonly="!editing || pay_receiver.type != 'liqpay_merchant'"
      />
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.liqpay_api_privkey')"
        :type="editing ? 'text': 'password'"
        :readonly="!editing || pay_receiver.type != 'liqpay_merchant'"
        v-model="pay_receiver.liqpay_private_key"
      />
      <!-- <div class="no-liqpay">
        <p class="comment c-grey">
          {{$t('settings_cafe.liqpay.liqpay_no_account')}}
          <a
            href="https://www.liqpay.ua/uk/registration/"
            class="c-green"
            target="_blank"
          >{{$t('settings_cafe.liqpay.register')}}</a>
        </p>
        
      </div> -->
      <p class="comment c-grey">
          {{$t('settings_cafe.liqpay.no_account')}}
          <a
            href="https://www.liqpay.ua/uk/registration/"
            class="register-link c-green"
            target="_blank"
          >{{$t('settings_cafe.liqpay.register_it')}}</a> ({{
            $t('settings_cafe.liqpay.liqpay_register_condition')
          }})
        </p> 
        <p class="comment">
          {{ $t('settings_cafe.liqpay.confirm_tip') }} <a class="register-link c-green" href="/icons/apple-pay-guide.png" target="_blank">{{ $t('settings_cafe.liqpay.apple_pay_tip') }}</a>
        </p>
    </div>
    <hr>
    <CircleToggle
      :value="pay_receiver.type == 'wayforpay_merchant'"
      @input="selectType('wayforpay_merchant')"
      :class="{
        'circle-row': true,
      }"
      v-if="allowWayforpay"
    >
    <!-- {{$t('settings_cafe.liqpay.wayforpay_account')}} -->
    <img class="payment-gateway-icon" src="/icons/wayforpay.png"> 
    
      <span class="c-grey">
        | {{ $t('settings_cafe.liqpay.comission') }} 2.5%
      </span>
    </CircleToggle>

    <div class="liqpay-settings" v-if="pay_receiver.type == 'wayforpay_merchant' && allowWayforpay">
      <p class="comment">{{$t('settings_cafe.liqpay.wayforpay_explain')}}</p>

      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.wayforpay_account_ph')"
        v-model="pay_receiver.wayforpay_merchant"
        :readonly="!editing || pay_receiver.type != 'wayforpay_merchant'"
      />
      <BaseInput
        class="input-pay"
        :placeholder="$t('settings_cafe.liqpay.wayforpay_secret_ph')"
        :type="editing ? 'text': 'password'"
        :readonly="!editing || pay_receiver.type != 'wayforpay_merchant'"
        v-model="pay_receiver.wayforpay_password"
      />
        <p class="comment c-grey">
          {{$t('settings_cafe.liqpay.no_account')}}
          <a
            href="https://wayforpay.com/ru"
            class="register-link c-green"
            target="_blank"
          >{{$t('settings_cafe.liqpay.register_it')}}</a>
        </p> 
        <!-- <p class="comment">
          {{ $t('settings_cafe.liqpay.confirm_tip') }} <a href="/icons/apple-pay-guide.png" target="_blank">{{ $t('settings_cafe.liqpay.apple_pay_tip') }}</a>
        </p> -->
    </div>

    <hr>
    <CircleToggle
      :value="pay_receiver.type == 'stripe_account'"
      @input="selectType('stripe_account')"
      :class="{
        'circle-row': true,
      }"
      v-if="allowWayforpay"
    >
    <!-- {{$t('settings_cafe.liqpay.wayforpay_account')}} -->
    <img class="payment-gateway-icon" src="/icons/stripe.svg"> 
    
      <span class="c-grey">
        | {{ $t('settings_cafe.liqpay.comission') }} 1.4-2.9%
      </span>
    </CircleToggle>
    <div class="liqpay-settings" v-if="pay_receiver.type == 'stripe_account' && allowStripe">
      <p class="comment">{{$t('settings_cafe.liqpay.stripe_explain')}}</p>

      <div @click="connectStripe" v-if="!cafe.pay_receiver.stripe_account">
        <img class="stripe-connect-button" src="/icons/stripe-connect.png" alt="">
      </div>
      <div v-else>
        <p class="comment c-green">
          {{ $t('settings_cafe.liqpay.stripe_active') }}
        </p>
        <DashboardButton class="iqos-group-item" @click="openStripeDashboard">
          {{ $t('settings_cafe.liqpay.stripe_open_btn') }}
          </DashboardButton>
      </div>
    </div>

    <!-- <InfoModal v-if="apple_pay_modal" @close="apple_pay_modal = false">
      <img src="/icons/apple-pay-guide.png" alt="">
    </InfoModal> -->

    <small>{{$t('settings_cafe.liqpay.data_is_protected')}}</small>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="saveChanges" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS";
import IQOSActions from "@/components/IQOSActions";
import CircleToggle from "@/components/CircleToggle";

import StripeAPI from '@/api/stripe'

import InfoModal from "@/components/modals/InfoModal.vue"

import BlackInput from "@/components/BlackInput.vue";

import DashboardButton from "@/components/DashboardButton.vue"

export default {
  data() {
    return {
      pay_receiver: {
        type: "card",
        card_number: null,

        account: null,
        mfo: null,
        okpo: null,
        company: null,

        liqpay_public_key: null,
        liqpay_private_key: null,

        wayforpay_merchant: null,
        wayforpay_password: null
      },
      editing: false,

      apple_pay_modal: false
    };
  },
  methods: {
    reset() {
      if (this.cafe.pay_receiver) {
        this.pay_receiver = Object.assign(
          this.pay_receiver,
          this.cafe.pay_receiver
        );
      }
    },
    selectType(type) {
      if (this.editing) {
        this.pay_receiver.type = type;
      }
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    saveChanges() {
      if (this.pay_receiver.liqpay_public_key) {
        this.pay_receiver.liqpay_public_key = this.pay_receiver.liqpay_public_key.trim();
      }

      if (this.pay_receiver.liqpay_private_key) {
        this.pay_receiver.liqpay_private_key = this.pay_receiver.liqpay_private_key.trim();
      }

      this.$store.commit("setCafePayReceiver", {
        mode: "inside",
        pay_receiver: this.pay_receiver
      });

      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    connectStripe() {
      StripeAPI.connect(this.cafe._id).then(ok => {
        this.$store.dispatch('fetchCafe');
      }).catch(error => {
        alert(`Stripe error :(`);
      }); 
    },
    openStripeDashboard() {
      StripeAPI.getOnboardingLink(this.cafe._id).then(data => {
        if (data.url) window.location.href = data.url;
      }).catch(error => {
        consol.error(error);
      });
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    allowP2p() {
      return this.cafe.pay_receiver.card_number;  
      // return this.$store.getters['worldwide/checkFeature']('p2p');
    },
    allowLiqpay() {
      return this.$store.getters['worldwide/checkPaymentGateway']('liqpay');
    },
    allowWayforpay() {
      return this.$store.getters['worldwide/checkPaymentGateway']('wayforpay');
    },
    allowStripe() {
      return this.$store.getters['worldwide/checkPaymentGateway']('stripe');
    },
    canShowBlockAtAll() {
      return this.allowP2p || this.allowLiqpay || this.allowWayforpay || this.allowStripe;
    }
  },
  components: {
    IQOS,
    IQOSActions,
    CircleToggle,
    BlackInput,
    InfoModal,
    DashboardButton
  }
};
</script>

<style scoped>
p.comment {
  padding-top: 1.5vh;
  line-height: normal;
  font-size: 1.7vh;
}

small {
  padding-top: 2vh;
  font-size: 1.3vh;
  display: block;
  line-height: normal;
  text-align: center;
  color: #908f8d;
}

.input-pay {
  width: 100%;
  margin-top: 1.2vh;
}

img.accept-to-pay {
  margin: 1vh 0 0 2vh;
  height: 3.5vh;
}

.no-liqpay {
  text-align: center;
}

.payment-gateway-icon {
  display: inline-block;
  width: 9vh !important;
  height: auto !important;
}

.register-link {
  font-size: 1.7vh;
}

.stripe-connect-button {
  width: 25vh;
  margin-top: 1.5vh;
  cursor: pointer;
}
</style>